import React, { useEffect } from "react";
import "./Faq.css";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import { Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getFaq } from "../../features/faq/Slice";
import parse from "html-react-parser";

function Faq() {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Faq", link: "", isActive: true },
  ];

  const faq = useSelector((state) => state.faq.getfaq);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFaq());
  });
  return (
    <>
      <section className="Faq_page_holder">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        {faq?.length > 0 ? (
          <div className="container">
            <div className="heading_holder mb-5">
              <h4 className="heading_text text-dark">FAQs</h4>{" "}
            </div>
            <div className="faq_holder">
              <Accordion defaultActiveKey="0">
                {faq?.map((faq, index) => (
                  <Accordion.Item className="outer_accordion_item" eventKey="0">
                    <div className="heading_holder">
                      <h6>{faq?.name}</h6>
                    </div>
                    <div className="inner_accordion_holder">
                      {faq?.Faqs?.map((faqs) => (
                        <Accordion defaultActiveKey="0">
                          <Accordion.Item
                            className="inner_accordion_item"
                            eventKey={index}
                          >
                            <Accordion.Header>
                              {parse(faqs?.question)}
                            </Accordion.Header>
                            <Accordion.Body>
                              {parse(faqs?.answer)}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))}
                    </div>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        ) : (
          <p style={{ textAlign: 'center', fontWeight: 'bold' }}>No Faq Available</p>

        )}
      </section>
    </>
  );
}

export default Faq;
